import React, { useEffect } from 'react';
import connect from 'react-redux/es/connect/connect';
import { withTranslation } from 'react-i18next';
import { Formik } from 'formik';
import { compose } from 'redux';
import { history } from '../../store';
import { Grid } from 'semantic-ui-react';

import { locationsActions } from '../../behavior/locations';
import GridColumnInputWrapper from '../common/GridColumnInputWrapper';
import ButtonWrapper from '../common/ButtonWrapper';
import CommonTagsInputWrapper from '../common/CommonTagsInputWrapper';

const BSearch = ({ buildingList, getBuildingList, width }) => {
  const formikRef = React.useRef(null);

  useEffect(() => {
    loadOnStart();
    document.addEventListener('keydown', onEnterPress, false);
  }, []);

  const onEnterPress = e => {
    e.stopPropagation();
    if (e.keyCode === 13) {
      if (formikRef && formikRef.current !== null) {
        if (formikRef.current.state.values.location) {
          history.push(`/buildings/num/${formikRef.current.state.values.location.buildingNum}`);
        }
      }
    }
  };

  const loadOnStart = () => {
    if (!buildingList || buildingList.length === 0) getBuildingList();
  };

  const submitHandle = (values, actions) => {
    if (values.location) history.push(`/buildings/num/${values.location.buildingNum}`);
    actions.setSubmitting(false);
  };

  const getSearchField = () => {
    return (
      <Formik
        ref={formikRef}
        initialValues={{}}
        onSubmit={submitHandle}
        render={formikProps => (
          <Grid doubling stackable columns={1}>
            <GridColumnInputWrapper
              {...formikProps}
              width={width}
              name="location"
              render={props => (
                <CommonTagsInputWrapper
                  {...props}
                  suggestionList={buildingList}
                  matchProperty="locationInfoWithAcronym"
                  displayProps="locationInfoWithAcronym"
                  maxTags={1}
                  value={formikProps.values.location}
                  className="inputWithInputDefaultButton containerReducedWhiteSpace "
                  placeholder="building.generic.search.for.a.building.placeholder"
                  startsWithOnly={false}
                  renderDefaultButtons={
                    <ButtonWrapper
                      icon="search"
                      className="mini inputWiderButton"
                      onClick={formikProps.handleSubmit}
                      disabled={!formikProps.values.location}
                    />
                  }
                />
              )}
            />
          </Grid>
        )}
      />
    );
  };

  return getSearchField();
};

BSearch.defaultProps = {
  width: 3,
};

const mapStateToProps = state => ({
  ...state.locations,
});

const mapDispatchToProps = dispatch => ({
  getBuildingList: () => dispatch(locationsActions.getLocationAutocompleteList(true)),
  resetBuildingSummary: () => dispatch(locationsActions.resetBuildingSummary()),
});

export default compose(withTranslation(), connect(mapStateToProps, mapDispatchToProps))(BSearch);
